import request from '/@/utils/request';
const { VITE_OAUTH_API } = import.meta.env;

/**
 * 登录api接口集合
 * @method signIn 用户登录
 * @method signOut 用户退出登录
 */
export function useLoginApi() {
  return {
    signIn: (params: any) => {
      return request.post('/auth/doLogin', params, { baseURL: '/gateway/cadexam-auth/' });
    },
    signOut: () => {
      return request.post('/api/logout', null, { baseURL: '/gateway/cadexam-auth/' });
    },
    // 微信二维码
    getWxQrCode: (params: { redirect_uri?: string; code_only?: string }) => {
      return request({
        url: `${VITE_OAUTH_API}/oauth2/third/wx/open/code`,
        params,
      });
    },
    // qq二维码
    getQqQrCode: (params: { redirect_uri?: string; code_only?: string }) => {
      return request({
        url: `${VITE_OAUTH_API}/oauth2/third/qq/open/code`,
        params,
      });
    },
    bindThird: (data: { unionId: string; appId: string; openId: string; loginType: string }) => {
      return request({
        url: `${VITE_OAUTH_API}/oauth2/third/bind`,
        method: 'POST',
        data,
      });
    },
    // 解除第三方账号绑定
    // loginType: 0:微信(包含网页应用和公众号) 1:QQ
    unbind: (data: { appId?: string; openId?: string; loginType: string }) => {
      return request({
        url: `${VITE_OAUTH_API}/oauth2/third/unbind`,
        method: 'POST',
        data,
      });
    },
  };
}

export function useUserApi() {
  return {
    getState: () => {
      return request.get('/auth/user/userState', { baseURL: '/gateway/cadexam-auth/' });
    },
    getInfo: () => {
      return request.get('/api/user/info', { baseURL: '/gateway/cadexam-auth/' });
    },
    getInfoNew: (params: { hyposensitization?: string }) => {
      return request({
        baseURL: '/gateway/cadexam-auth/',
        url: '/api/user/info',
        params,
      });
    },
    getMessage: () => {
      return request.get('/api/user/unReadMessageCount', { baseURL: '/gateway/cadexam-old/' });
    },
    getSchool: (id: string | number) => {
      return request.get(`/api/school/info/${id}`, { baseURL: '/gateway/cadexam-old/' });
    },
    updateUserInfo: (data: any) => {
      return request({
        baseURL: '/gateway/cadexam-auth/',
        url: '/api/user/modify',
        method: 'PUT',
        // headers: { "Content-Type": "application/x-www-form-urlencoded;charset=utf-8" },
        data,
      });
    },
    checkUserAuth: () => {
      return request.get('/api/cert/checkIsCertUser');
    },
    authRealName: (data: { userId: number; name: string; idCard: string }) => {
      return request({
        baseURL: '/gateway/cadexam-auth/',
        url: '/api/user/authRealName',
        method: 'put',
        data,
      });
    },
    queryCourses: (
      data: { pageIndex: number; pageSize: number; states?: number | string } = { pageIndex: 1, pageSize: 10 }
    ) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/user/getUserCourseList',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        data,
      });
    },
    setTopCourse: (id: number | string) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: `/api/user/sortUserCourse/${id}`,
      });
    },
    cancelSetTopCourse: (id: number | string) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: `/api/user/unSortUserCourse/${id}`,
      });
    },
    finishCourse: (id: number | string) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: `/api/user/finishUserCourse/${id}`,
      });
    },
    deleteCourse: (id: number | string) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: `/api/user/deleteUserCourse/${id}`,
      });
    },
    querySeries: (
      data: { pageIndex: number; pageSize: number; states?: number | string } = { pageIndex: 1, pageSize: 10 }
    ) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/user/getUserCourseSeriesList',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        data,
      });
    },
    setTopSeries: (id: number | string) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: `/api/user/sortUserCourseSeries/${id}`,
      });
    },
    cancelSetTopSeries: (id: number | string) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: `/api/user/unSortUserCourseSeries/${id}`,
      });
    },
    finishSeries: (id: number | string) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: `/api/user/finishUserCourseSeries/${id}`,
      });
    },
    deleteSeries: (id: number | string) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: `/api/user/deleteUserCourseSeries/${id}`,
      });
    },
    queryAuth: (data: { pageIndex: number; pageSize: number } = { pageIndex: 1, pageSize: 10 }) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/certification/getCertificationContentList',
        method: 'post',
        data,
      });
    },
    queryMyJoinedTrain: (data: { pageIndex: number; pageSize: number } = { pageIndex: 1, pageSize: 10 }) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/train/myJoinedTrain',
        method: 'post',
        data,
      });
    },
    queryMyPublishTrain: (data: { pageIndex: number; pageSize: number } = { pageIndex: 1, pageSize: 10 }) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/train/myPublishTrain',
        method: 'post',
        data,
      });
    },
    getTrainInfo: (data: { trainId: string | number }) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/train/trainInfo',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        data,
      });
    },
    deleteTrain: (data: { contentId: string | number; trainId: string | number }) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/train/delTrain',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        data,
      });
    },
    queryExams: (
      data: { pageNum: number; pageSize: number; isTest?: string; studentCode?: string; examinationCode?: string } = {
        pageNum: 1,
        pageSize: 10,
      }
    ) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/userExam/getUserExamList',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        data,
      });
    },
    queryAuthExams: (params: { pageNum: number; pageSize: number } = { pageNum: 1, pageSize: 10 }) => {
      return request({
        url: '/api/exam/pageByUser',
        params,
      });
    },
    queryProducts: (data: { pageIndex: number; pageSize: number } = { pageIndex: 1, pageSize: 10 }) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/user/userProducts',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        params: data,
      });
    },
    postProductLike: (data: { contentId: string }) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/contentLikeLog/save',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        data,
      });
    },
    queryTopNotices: (data: { pageIndex: number; pageSize: number } = { pageIndex: 1, pageSize: 3 }) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/user/topNMesssages',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        data,
      });
    },
    queryNotices: (
      data: { pageIndex: number; pageSize: number; type: string } = { pageIndex: 1, pageSize: 10, type: 'System' }
    ) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/user/messsages',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        data,
      });
    },
    updateNotice: (data: any) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/user/readMesssage',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        data,
      });
    },
    queryContests: (data: { pageNum: number; pageSize: number } = { pageNum: 1, pageSize: 10 }) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/userContest/getUserContestListByUser',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        data,
      });
    },
    queryOrders: (data: { pageNum: number; pageSize: number } = { pageNum: 1, pageSize: 10 }) => {
      return request({
        url: '/api/order/userOrder',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        data,
      });
    },
    getOrderInfo: (params: { orderId: number | string }) => {
      return request({
        url: '/api/order',
        params,
      });
    },
    getCommodityInfo: (params: { id: number | string }) => {
      return request({
        url: '/api/commodity',
        params,
      });
    },
    queryApplications: () => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/certApply/getApplyList',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
      });
    },
    checkExpertAuth: () => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/user/expertAuth',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
      });
    },
    /**
     * 学生打印准考证
     */
    checkAdmissionTicker: (data: { studentId: number }) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/userExam/checkExamStudentTicketWithIdCode',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        data,
      });
    },
    checkGrades: (data: { studentId: string; examinationCode: string }) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/userExam/getExamStudentResult',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        data,
      });
    },
    checkAuthInfo: () => {
      return request({
        baseURL: '/gateway/cadexam-auth/',
        url: '/api/user/getUserNameAuthInfo',
        method: 'put',
      });
    },
    cancelBindPhone: () => {
      return request({
        baseURL: '/gateway/cadexam-auth/',
        url: '/api/user/unBindPhone',
        method: 'put',
      });
    },
    cancelBindEmail: () => {
      return request({
        baseURL: '/gateway/cadexam-auth/',
        url: '/api/user/unBindEmail',
        method: 'put',
      });
    },
    bindPhone: (data: { phoneNumber: string; verifyCode: string }) => {
      return request({
        baseURL: '/gateway/cadexam-auth/',
        url: '/api/user/verifyPhone',
        method: 'put',
        data,
      });
    },
    bindEmail: (data: { verifyCode: string; email: string }) => {
      return request({
        baseURL: '/gateway/cadexam-auth/',
        url: '/api/user/verifyEmail',
        method: 'put',
        data,
      });
    },
    getPhoneCode: (params: { verifyType: string; phoneNumber: string }) => {
      return request({
        url: `${VITE_OAUTH_API}/oauth2/code/phone`,
        method: 'GET',
        params,
      });
    },
    getEmailCode: (params: { verifyType: string; email: string }) => {
      return request({
        url: `${VITE_OAUTH_API}/oauth2/code/email`,
        method: 'GET',
        params,
      });
    },
    // 通过手机号重置密码
    resetPwdByPhone: (data: { phoneNumber: string; newPassword: string; verifyCode: string }) => {
      return request({
        baseURL: '/gateway/cadexam-auth/',
        url: '/api/user/changePasswordByPhone',
        method: 'PUT',
        data,
      });
    },
    // 通过邮箱重置密码
    resetPwdByEmail: (data: { email: string; newPassword: string; verifyCode: string }) => {
      return request({
        baseURL: '/gateway/cadexam-auth/',
        url: '/api/user/changePasswordByEmail',
        method: 'PUT',
        data,
      });
    },
    // 修改密码
    fortePwd: (data: { oldPassword: string; newPassword: string }) => {
      return request({
        baseURL: '/gateway/cadexam-auth/',
        url: '/api/user/changePassword',
        method: 'put',
        data,
      });
    },
    // 查询是否有权限修改学校
    checkModifySchool: () => {
      return request({
        baseURL: '/gateway/cadexam-auth/',
        url: '/api/user/ifCanChangeSchool',
      });
    },
    // 发票信息
    saveOrderInvoice: (data) => {
      return request({
        baseURL: '/gateway/cadexam-system/',
        url: '/api/order/invoice',
        method: 'post',
        data,
      });
    },
    // 下载发票
    downloadOrderInvoice: (params) => {
      return request({
        baseURL: '/gateway/cadexam-system/',
        url: '/api/order/invoice/url',
        params,
      });
    },
  };
}

export function useCommonApi() {
  return {
    downloadFile: (params: any) => {
      return request({
        baseURL: '/gateway/cadexam-old/',
        url: '/api/file/getDownloadUrl',
        params,
      });
    },
  };
}
